module.exports = __webpack_public_path__ + "static/template_options_year_months_as_rows-be46127f261c71d4b3b62d9f51bb452e.png";